<template>
    <div id="clients">
        <div class="container">
            <h2 class="title">{{ $t("message.our_clients") }}</h2>
        </div>

        <div class="container">
            <div id="iframe-clients" :class="{ mobile: isMobile }" ref="iframeContainer"></div>
        </div>

        <!--
            <div class="container">
                <div id="iframe-clients" :class="{ mobile: isMobile }">
                    <iframe src="./clients/index.html" ref="iframe" loading="lazy"></iframe>
                </div>
            </div>
            -->
    </div>
</template>

<script>
export default {
    name: "Clients",
    data() {
        return {
            isMobile: false,
        };
    },
    components: {},
    beforeCreate() {
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;
        if (windowWidth < 992 && windowWidth < windowHeight) {
            window.isMobile = true;
        } else {
            window.isMobile = false;
        }
    },
    mounted() {
        let _this = this;
        window.addEventListener("resize", function (e) {
            _this.isItMobile();
        });
        this.isItMobile();

        window.addEventListener("load", () => {
            const iframe = document.createElement("iframe");
            iframe.src = "./clients/index.html";
            iframe.loading = "lazy";
            iframe.setAttribute("ref", "iframe"); // si tu veux garder un ref (note : pas exploitable en DOM)
            this.$refs.iframeContainer.appendChild(iframe);
        });
    },
    methods: {
        isItMobile() {
            const iframe = this.$refs.iframe;
            let statusMobile = {};

            let windowWidth = window.innerWidth;
            let windowHeight = window.innerHeight;

            if (windowWidth < 992) {
                this.isMobile = true;

                if (windowWidth > windowHeight) {
                    this.isMobile = false;
                }

                if (iframe) {
                    statusMobile.isMobile = this.isMobile;
                    statusMobile = JSON.stringify(statusMobile);
                    iframe.contentWindow.postMessage(statusMobile, "*");
                }
            }

            if (windowWidth >= 992) {
                this.isMobile = false;

                if (iframe) {
                    statusMobile.isMobile = this.isMobile;
                    statusMobile = JSON.stringify(statusMobile);
                    iframe.contentWindow.postMessage(statusMobile, "*");
                }
            }
        },
    },
};
</script>

<style lang="scss">
#iframe-clients {
    margin: auto;
    width: 100%;
    max-width: 1400px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 25%;
    position: relative;

    iframe {
        border: 0;
        width: 100%;
        height: 100%;
        border-radius: 30px;
        position: absolute;
        top: 0;
    }

    &.mobile {
        padding-top: 100%;
    }
}
</style>

<style scoped lang="scss">
#clients {
    position: relative;
}

.title {
    font-family: Oswald, sans-serif;
    text-transform: uppercase;
    background: linear-gradient(to left, rgb(255, 0, 0), rgb(121, 121, 244));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 900;
    font-size: 2.4rem;
    text-align: center;
    padding: 2rem 0 2rem;
    box-sizing: border-box;
    margin: 0;
}
.splide img {
    width: 90%;
    margin: auto;
    display: block;
}

@media (max-width: 1400px) {
    .title {
        font-size: 3rem;
        padding: 4rem 0 1.4rem;
    }
    .splide img {
        width: 90%;
    }
}

@media (max-width: 992px) {
    .title {
        font-size: 2.8rem;
        padding: 4rem 0 1.2rem;
    }
    .splide img {
        width: 100%;
    }
}

@media (max-width: 768px) {
    .title {
        font-size: 2.4rem;
    }
}

@media (max-width: 576px) {
    .title {
        font-size: 2rem;
        padding: 3rem 0 0.5rem;
    }
    .splide img {
        width: 100%;
    }
}
</style>
